export const beautyLevelTwo = [
    {
      name: "Makeup",
      categoryId: "beauty_makeup",
      parentCategoryId: "beauty",
      level: 2,
    },
    {
      name: "Skincare",
      categoryId: "beauty_skincare",
      parentCategoryId: "beauty",
      level: 2,
    },
    {
      name: "Hair Care",
      categoryId: "beauty_hair_care",
      parentCategoryId: "beauty",
      level: 2,
    },
    {
      name: "Fragrance",
      categoryId: "beauty_fragrance",
      parentCategoryId: "beauty",
      level: 2,
    },
    {
      name: "Personal Care",
      categoryId: "beauty_personal_care",
      parentCategoryId: "beauty",
      level: 2,
    }
  ];
  